import { render, staticRenderFns } from "./communitymassdemands.vue?vue&type=template&id=75c48686&scoped=true&"
import script from "./communitymassdemands.vue?vue&type=script&lang=js&"
export * from "./communitymassdemands.vue?vue&type=script&lang=js&"
import style0 from "./communitymassdemands.vue?vue&type=style&index=0&id=75c48686&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c48686",
  null
  
)

export default component.exports